import React, { useState } from "react";
import Logo from "../../assets/images/login/logo.png";
import {
    TextField,
    Button,
    Typography,
    Box,
    FormControl,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import AgreeSec from "../agree-sec";
import { useTheme } from "@mui/material/styles";

function DeleteAccount() {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(""); 
    const [openPopup, setOpenPopup] = useState(false);
    const theme = useTheme();

    const handleChange = (event) => {
        setEmail(event.target.value);
        setEmailError(""); 
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            setEmailError("Email is required.");
            
            return;
        }

        if (!emailRegex.test(email)) {
            setEmailError("Enter a valid email address.");
            return;
        }


        setTimeout(() => {
            setOpenPopup(true);
        }, 2000);
    };

    return (
        <>
            <Box className="login-wrapper">
                <Grid container spacing={2} sx={{ height: "100%" }}>
                   
                    <Grid item xs={6}>
                        <Box sx={{ m: "32px 80px" }}>
                            <img src={Logo} alt="logo" />
                        </Box>
                    </Grid>

                    
                    <Grid item xs={6}>
                        <Stack
                            sx={{
                                height: "100%",
                                width: "50%",
                                margin: "0 auto",
                                position: "relative",
                            }}
                            justifyContent={"start"}
                            alignItems={"center"}
                        >
                            <Box sx={{ width: "100%", paddingTop: { xs: "50px", xl: "190px" } }}>
                                <Typography
                                    variant="h1"
                                    sx={{ color: "#fff", fontSize: "40px", fontWeight: "700" }}
                                >
                                    Delete Your Account
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ color: "#CBD2E2", fontSize: "16px", fontWeight: "500", mt: "12px", mb: "28px" }}
                                >
                                    Enter your email to delete your Account securely.
                                </Typography>
                            </Box>

                           
                            <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <TextField
                                        type="email"
                                        name="email"
                                        value={email}
                                        onChange={handleChange}
                                        placeholder="Enter your email"
                                        sx={{ color: "#fff", input: { color: "#fff" } }}
                                        InputProps={{ sx: { color: "#fff" } }}
                                        error={!!emailError}
                                        helperText={emailError}
                                        
                                    />
                                </FormControl>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{
                                        mb: 2,
                                        p: "10px",
                                        fontSize: "18px",
                                        fontWeight: "500",
                                        borderRadius: "50px",
                                        height: "auto",
                                    }}
                                >
                                    Delete Account
                                </Button>
                            </Box>

                            
                            <Box
                                sx={{
                                    position: "absolute",
                                    bottom: { xs: "4px", xl: "24px" },
                                    left: 0,
                                    right: 0,
                                }}
                            >
                                <AgreeSec />
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>

           
            <Dialog
                open={openPopup}
                onClose={() => setOpenPopup(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .css-umy2on-MuiPaper-root-MuiDialog-paper": {
                        width: "375px",
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}></DialogTitle>
                <DialogContent>
                    <Typography
                        sx={{
                            color: theme.palette.secondary.main,
                            fontWeight: "700",
                            fontSize: "18px",
                        }}
                    >
                        Your Account will be deleted in 7 days.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setOpenPopup(false);  
                            setEmail("");
                        }}
                        sx={{ p: 0, minWidth: "auto", height: "auto", color: "#fff" }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default DeleteAccount;
